export default function () {
    return {
        KEYS: {
            IMPORT_CREATE: 'IMPORT_CREATE',
            IMPORT_UPDATE: 'IMPORT_UPDATE'
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/company/user/import/type/index.js